import React from 'react';
import PropTypes from 'prop-types';
import HelpRoundedIcon from '@material-ui/icons/HelpRounded';
import styles from './styles.scss';

class TooltipSpan extends React.Component {
    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        // Children may be an array or a single element.
        // Calling find on Props.Children that is a single element will throw;
        const children = React.Children.toArray(props.children);

        const defaultIcon = (
            <span style={{ color: '#18A0FB' }}>
                <HelpRoundedIcon />
            </span>
        );

        const icon = children.length > 1
            ? children.filter((c) => `${c?.type?.name}`.toLowerCase() !== 'tooltip')
            : defaultIcon;

        const tooltip = children.find((c) => `${c?.type?.name}`.toLowerCase() === 'tooltip');

        this.state = { show: false, icon, tooltip };
    }

    show() {
        this.setState((s) => ({
            show: !s.show,
        }));
    }

    hide() {
        this.setState(() => ({
            show: false,
        }));
    }

    render() {
        const { show, icon, tooltip } = this.state;
        let { zindex } = this.props;
        const display = show ? 'block' : 'none';

        // We want to set up a props object for a tooltip
        const ttprops = { doClose: this.hide };
        // Can't set props on the "tooltip" Component directly because it is immutable
        // https://stackoverflow.com/questions/47471131/why-are-react-props-immutable
        // Therefore we need to clone the Component and set the props
        const tooltipClone = React.cloneElement(tooltip, ttprops);

        // svgs don't work with z-index.
        // Workaround is to add it to tooltipspan.
        // We need to specify the specific order as well because svg "z-index" is determined
        // by the position in the DOM tree. The lower it is, higher the "z-index" is.
        if (typeof zindex !== 'number') {
            zindex = parseInt(zindex, 10);
        }

        // NB: Now render the TooltipSpan with the *clone* of the tooltip instead
        return (
            <span
                style={{ zIndex: zindex }}
                className={styles.tooltipspan}
                onMouseEnter={this.show}
                onMouseLeave={this.hide}
                role="button"
                tabIndex={0}
            >
                <span
                    onClick={this.show}
                    role="button"
                    tabIndex={0}
                >
                    {icon}
                </span>
                <span
                    style={{ display }}
                    className={styles.customtooltipcontainer}
                >
                    {tooltipClone}
                </span>
            </span>
        );
    }
}

TooltipSpan.propTypes = {
    children: PropTypes.node.isRequired,
    zindex: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

TooltipSpan.defaultProps = {
    zindex: 2,
};

export default TooltipSpan;
